import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { AppLoaderComponent } from 'app/shared/app-loader/app-loader.component';

import { TranslateService } from '@ngx-translate/core';
import { WebViewerInstance } from '@pdftron/webviewer';

import { DownloadListComponent } from '../download-list/download-list.component';
import { setClearWatermarkOptions, setWatermarkOptions } from './set-watermark.service';
import { WatermarkDMS } from '../../../shared/types';
import { DocumentData } from '../document-data.type';

/**
 * Show a dialog box asking user to confirm if they want to print document.
 * User can also choose to include 'Annotation' and/or 'Watermark' into the document.
 */
export function promptPrintConfirmDialog(instance: WebViewerInstance, documentData: DocumentData, dialog: MatDialog, translate: TranslateService, loader?: AppLoaderComponent) {
        /** Config Dialog box */
        let dialogConfig: {
            title: string,
            list: { id: number, selected: boolean, name: string }[],
        } = {
            title: "",
            list: []
        };

        translate.get("viewDocument.print").subscribe((dialogTitle: string) => {
            dialogConfig.title = dialogTitle;
        });
        translate.get("Annotation").subscribe((annotationCheckboxLabel: string) => {
            dialogConfig.list.push({ id: 1, selected: false, name: annotationCheckboxLabel });
        });
        if (documentData.watermark) {
            translate.get("Watermark").subscribe((watermarkCheckboxLabel: string) => {
                dialogConfig.list.push({ id: 2, selected: false, name: watermarkCheckboxLabel });
            });
        }
        /** Show Print Confirmation Dialog Box */
        const dialogRef = dialog.open(DownloadListComponent, {
            data: dialogConfig,
        });

        /** Retrieve user's checked/unchecked checkbox options */
        let checkboxStatus: typeof dialogConfig.list;
        const dialogSubmit = dialogRef.componentInstance.submitData.subscribe(
            (_checkboxStatus: typeof dialogConfig.list) => {
                checkboxStatus = _checkboxStatus;
                dialogSubmit.unsubscribe();
            }
        );

        /**  Print doc if user clicked 'Print' or do nothing if 'Cancel' */
        dialogRef.afterClosed().subscribe((confirmPrint: boolean) => {
            if (confirmPrint) {
                setPrint(
                    instance,
                    checkboxStatus[0].selected,
                    (checkboxStatus[1]?.selected) ? documentData.watermark : undefined,
                    loader
                );
            }
        });
}

function setPrint(instance: WebViewerInstance, includeAnnotations: boolean, watermark?: WatermarkDMS, loader?: AppLoaderComponent) {
    instance?.UI.setPrintQuality(2);
    if (!watermark) {
        setClearWatermarkOptions(instance);
    }
    else {
        setWatermarkOptions(instance, watermark);
    }

    loader?.show();
    try {
        instance?.UI.printInBackground({
            includeAnnotations: includeAnnotations,
            onProgress: (pageNumber) => {
                if (pageNumber === instance.Core.documentViewer.getDocument().getPageCount()) {
                    if (watermark) {
                        setWatermarkOptions(instance, watermark);
                    }
                    loader?.hide();
                }
            }
        });
    }
    finally {
        loader?.hide();
    }
}